export default __webpack_public_path__ + "static/media/HDTX_Annual Report 2020.b34b6187.pdf";